<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-menu fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.name"
                  :rules="validation.name"
                  required
                  placeholder="E.g. Agua"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="pt-4" v-if="isHomeVersionPremium">
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Imagen :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="4" class="py-0 py-sm-1">
                <FileInput
                  :value="menuImage"
                  :type="'category'"
                  @setImageUrl="setImageUrl($event)"
                  accept="image/png, image/jpeg, image/jpg"
                />
              </v-col>
              <v-col cols="12" sm="2" class="py-0 py-sm-1 d-flex">
                <div class="menu-img">
                  <img :src="input.menu_image" :alt="input.menu_image" />
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }">
                  Color Principal :
                </v-subheader>
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1 d-flex">
                <v-text-field
                  v-model="input.primaryColor"
                  placeholder="E.g. #F8D1AC"
                  @input="changeColor('menuGroupPrimary')"
                ></v-text-field>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn :color="menuGroupPrimary" dark v-on="on"> </v-btn>
                  </template>
                  <v-color-picker
                    value="#7417BE"
                    v-model="menuGroupPrimary"
                    hide-canvas
                    hide-inputs
                    show-swatches
                    class="mx-auto"
                    @input="onChangeColor('menuGroupPrimary')"
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }">
                  Color Segundario :
                </v-subheader>
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1 d-flex">
                <v-text-field
                  v-model="input.secondaryColor"
                  placeholder="E.g. #C3C0B5"
                  @input="changeColor('menuGroupSecondary')"
                ></v-text-field>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn :color="menuGroupSecondary" dark v-on="on"> </v-btn>
                  </template>
                  <v-color-picker
                    value="#7417BE"
                    v-model="menuGroupSecondary"
                    hide-canvas
                    hide-inputs
                    show-swatches
                    class="mx-auto"
                    @input="onChangeColor('menuGroupSecondary')"
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Precio :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.price"
                  :rules="validation.price"
                  type="number"
                  required
                  placeholder=""
                  suffix="€"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Description :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-text-field v-model="input.description"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >¿Es de plato unico? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.isStarter" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >¿Incluye Bebida? :
                </v-subheader>
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.isDrink" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >¿Incluye Postres? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.isDessert" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <div v-if="input.isDrink">
              <MenusExpansionPanels
                type="Drink"
                ref="drinkExpansionPanels"
                :accordionsPanel="drinksPanel"
                :headers="headers"
                :getCollections="getDrinks"
                :searchInput.sync="searchDrinks"
                :categories="categoriesDrink"
                :categorySelected.sync="drinksCategorySelected"
                :selection="selection"
                :selectionSelected.sync="drinksSelectionSelected"
                title="Selecciona el BEBIDA"
                @onChangeSelection="onDrinkSelect"
                @addAdditionalCharge="addAdditionalChargeForDrinks"
              />
            </div>
            <br />
            <div>
              <MenusExpansionPanels
                type="Primero"
                ref="primeroExpansionPanels"
                :accordionsPanel="foodPanel"
                :headers="headers"
                :getCollections="getPrimeros"
                :searchInput.sync="searchPrimero"
                :categories="categoriesPrimero"
                :categorySelected.sync="primeroCategorySelected"
                :selection="selection"
                :selectionSelected.sync="primeroSelectionSelected"
                title="Selecciona el PRIMERO"
                @onChangeSelection="onStarterSelect"
                @addAdditionalCharge="addAdditionalCharge"
              />
            </div>
            <br v-if="!input.isStarter" />
            <div v-if="!input.isStarter">
              <MenusExpansionPanels
                type="Segundo"
                ref="segundoExpansionPanels"
                :accordionsPanel="foodPanel"
                :headers="headers"
                :getCollections="getSegundo"
                :searchInput.sync="searchMaincourse"
                :categories="categoriesSegundo"
                :categorySelected.sync="segundoCategorySelected"
                :selection="selection"
                :selectionSelected.sync="segundoSelectionSelected"
                title="Selecciona el SEGUNDO"
                @onChangeSelection="onMainCourseSelect"
                @addAdditionalCharge="addAdditionalChargeForSegundo"
              />
            </div>
            <br />
            <div v-if="input.isDessert">
              <MenusExpansionPanels
                type="Dessert"
                ref="dessertExpansionPanels"
                :accordionsPanel="dessertPanel"
                :headers="headers"
                :getCollections="getDessert"
                :searchInput.sync="searchDessert"
                :categories="categoriesDessert"
                :categorySelected.sync="dessertCategorySelected"
                :selection="selection"
                :selectionSelected.sync="dessertSelectionSelected"
                title="Selecciona el POSTRE"
                @onChangeSelection="onDessertSelect"
                @addAdditionalCharge="addAdditionalChargeForDessert"
              />
            </div>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    type="submit"
                    :style="adminNavigationBackTheme"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import FileInput from "@/components/common/FileInput";
import MenusExpansionPanels from "@/components/admin/menugroup/MenusExpansionPanels";
import moment from "moment";
import { saveUiMenuOrder } from "@/collections/uiMenuOrder";
import { saveScheduleMenuGroup } from "@/collections/scheduleMenuGroup";
import { MenuGroupDialogHeader } from "@/utils/tableHeaderconstants";
import { categoriesCollection } from "@/collections/categories";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
import { drinksCollection } from "@/collections/drinks";
import { getMenuGroupById, saveMenuGroup } from "@/collections/menuGroup";

export default {
  name: "menus-group-dialog",
  components: {
    Loader,
    FileInput,
    MenusExpansionPanels
  },
  data() {
    return {
      id: "addMenu",
      dialog: false,
      title: "",
      drinks: [],
      dessert: [],
      starters: [],
      maincourse: [],
      categoriesCollection: [],
      dialogLoader: false,
      isValid: false,
      input: {
        id: "",
        name: "",
        primaryColor: "",
        secondaryColor: "",
        description: "",
        price: 0,
        isDrink: true,
        isDessert: true,
        isStarter: true,
        starter_ids: [],
        maincourse_ids: [],
        drink_ids: [],
        dessert_ids: [],
        active: true,
        type: "menu_group",
        sort: 1000
      },
      validation: {
        name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
        price: [
          v =>
            (v !== undefined && parseFloat(v) > -1) ||
            "Por favor, introduce un Precio válido"
        ]
      },
      menusGroupCollection: [],
      drinksPanel: {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      },
      foodPanel: {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      },
      dessertPanel: {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      },
      searchPrimero: "",
      searchDrinks: "",
      searchDessert: "",
      searchMaincourse: "",
      menuGroupPrimary: "#7417BE",
      menuGroupSecondary: "#9E9E9E",
      headers: [...MenuGroupDialogHeader],
      drinksCategorySelected: "",
      primeroCategorySelected: "",
      segundoCategorySelected: "",
      dessertCategorySelected: "",
      drinksSelectionSelected: "",
      primeroSelectionSelected: "",
      segundoSelectionSelected: "",
      dessertSelectionSelected: "",
      selection: [
        {
          text: "Todos",
          value: ""
        },
        {
          text: "Si",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ]
    };
  },
  firestore() {
    return {
      drinks: drinksCollection.orderBy("name"),
      starters: foodCollection.where("canBeShared", "==", true).orderBy("name"),
      maincourse: foodCollection
        .where("canBeMainCourse", "==", true)
        .orderBy("name"),
      dessert: dessertCollection.orderBy("name"),
      categoriesCollection: categoriesCollection
    };
  },
  computed: {
    categoriesDrink() {
      // When a product type is selected it will automatically show the categories
      let drinkCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID ===
          category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...drinkCategory];
    },
    categoriesPrimero() {
      // When a product type is selected it will automatically show the categories
      let primeroCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID === category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...primeroCategory];
    },
    categoriesSegundo() {
      // When a product type is selected it will automatically show the categories
      let segundoCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID === category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...segundoCategory];
    },
    categoriesDessert() {
      // When a product type is selected it will automatically show the categories
      let dessertCategory = this.categoriesCollection.filter(
        category =>
          process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID ===
          category.product_type_id
      );
      return [{ id: "", name: "Todas" }, ...dessertCategory];
    },
    getDrinks() {
      let filterDrinks = this.drinks.filter(item => item.stock > 0);
      filterDrinks = filterDrinks.map(x => {
        let isActive = this.input.drink_ids.find(y => x.id === y.id);
        x.active = !!isActive;
        x.additional_charge = isActive ? isActive.additional_charge : 0;
        return x;
      });
      filterDrinks =
        this.searchDrinks !== ""
          ? filterDrinks.filter(x => {
              if (
                x.name.toLowerCase().includes(this.searchDrinks.toLowerCase())
              ) {
                return x;
              }
            })
          : filterDrinks;

      filterDrinks =
        this.drinksCategorySelected !== ""
          ? filterDrinks.filter(
              drink => this.drinksCategorySelected === drink.category_id
            )
          : filterDrinks;

      filterDrinks =
        this.drinksSelectionSelected !== ""
          ? filterDrinks.filter(
              drink => this.drinksSelectionSelected === drink.active
            )
          : filterDrinks;

      return filterDrinks;
    },
    getPrimeros() {
      let filterStarters = this.starters.filter(item => item.stock > 0);
      filterStarters = filterStarters.map(x => {
        let isActive = this.input.starter_ids.find(y => x.id === y.id);
        x.active = !!isActive;
        x.additional_charge = isActive ? isActive.additional_charge : 0;
        return x;
      });
      filterStarters =
        this.searchPrimero !== ""
          ? filterStarters.filter(x => {
              if (
                x.name.toLowerCase().includes(this.searchPrimero.toLowerCase())
              ) {
                return x;
              }
            })
          : filterStarters.filter(item => item.canBeShared === true);

      filterStarters =
        this.primeroCategorySelected !== ""
          ? filterStarters.filter(
              primero => this.primeroCategorySelected === primero.category_id
            )
          : filterStarters;

      filterStarters =
        this.primeroSelectionSelected !== ""
          ? filterStarters.filter(
              primero => this.primeroSelectionSelected === primero.active
            )
          : filterStarters;

      return filterStarters;
    },
    getSegundo() {
      let filterMaincourse = this.maincourse.filter(item => item.stock > 0);
      filterMaincourse = filterMaincourse.map(x => {
        let isActive = this.input.maincourse_ids.find(y => x.id === y.id);
        x.active = !!isActive;
        x.additional_charge = isActive ? isActive.additional_charge : 0;
        return x;
      });
      filterMaincourse =
        this.searchMaincourse !== ""
          ? filterMaincourse.filter(x => {
              if (
                x.name
                  .toLowerCase()
                  .includes(this.searchMaincourse.toLowerCase())
              ) {
                return x;
              }
            })
          : filterMaincourse.filter(item => item.canBeMainCourse === true);

      filterMaincourse =
        this.segundoCategorySelected !== ""
          ? filterMaincourse.filter(
              segundo => this.segundoCategorySelected === segundo.category_id
            )
          : filterMaincourse;

      filterMaincourse =
        this.segundoSelectionSelected !== ""
          ? filterMaincourse.filter(
              segundo => this.segundoSelectionSelected === segundo.active
            )
          : filterMaincourse;

      return filterMaincourse;
    },
    getDessert() {
      let filterDessert = this.dessert.filter(item => item.stock > 0);
      filterDessert = filterDessert.map(x => {
        let isActive = this.input.dessert_ids.find(y => x.id === y.id);
        x.active = !!isActive;
        x.additional_charge = isActive ? isActive.additional_charge : 0;
        return x;
      });
      filterDessert =
        this.searchDessert !== ""
          ? filterDessert.filter(x => {
              if (
                x.name.toLowerCase().includes(this.searchDessert.toLowerCase())
              ) {
                return x;
              }
            })
          : filterDessert;

      filterDessert =
        this.dessertCategorySelected !== ""
          ? filterDessert.filter(
              dessert => this.dessertCategorySelected === dessert.category_id
            )
          : filterDessert;

      filterDessert =
        this.dessertSelectionSelected !== ""
          ? filterDessert.filter(
              dessert => this.dessertSelectionSelected === dessert.active
            )
          : filterDessert;

      return filterDessert;
    },
    menuImage() {
      if (!this.input.menu_image) {
        return null;
      }

      return new File(
        [this.input.menu_image],
        this.input.menu_image
          .split("/")
          .pop()
          .split("?")[0]
      );
    }
  },
  methods: {
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    async submitForm() {
      try {
        if (this.$refs.form.validate()) {
          if (this.id !== "addMenu") {
            // edit Menu

            // check update unique name
            let found = this.menusGroupCollection.some(x => {
              if (
                x.name.toLowerCase().trim() ===
                  this.input.name.toLowerCase().trim() &&
                x.id.toLowerCase() !== this.id.toLowerCase()
              ) {
                return x;
              }
            });

            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }

            await this.saveMenu(this.id);
          } else {
            // Add Menu

            let found = this.menusGroupCollection.some(
              x =>
                x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim()
            );
            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }

            let id = this.uuidv4();
            await this.saveMenu(id);
            let scheduleDoc = {
              schedule: {}
            };

            for (let i = 0; i <= 6; i++) {
              scheduleDoc.schedule[i] = {
                first: {
                  init: 0,
                  fin: 0
                },
                second: {
                  init: 0,
                  fin: 0
                }
              };
            }

            scheduleDoc.menuId = id;
            saveScheduleMenuGroup(id, scheduleDoc).catch(error => {
              this.setlogError(
                "save_schedule_menu_group",
                "Obtained error message in submitForm()",
                error.stack,
                this.$options.name
              );
            });
          }
          this.showSuccessMessage("Carta guardada");

          setTimeout(() => {
            this.close();
          }, 500);
        }
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "save/update_menu_group",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    async saveMenu(id) {
      try {
        await saveMenuGroup(id, this.buildMenu());
        await saveUiMenuOrder(id, {
          ...this.buildMenu(),
          id: id,
          type: "menu_group",
          sort: 1000
        });
      } catch (error) {
        this.setlogError(
          "save/update_menu_group",
          "Obtained error message in saveMenu()",
          error.stack,
          this.$options.name
        );
      }
    },
    buildMenu() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    addAdditionalCharge(product) {
      let found = this.input.starter_ids.find(item => item.id === product.id);
      if (found) {
        this.input.starter_ids.map(item => {
          if (item.id === product.id) {
            return (item.additional_charge = product.additional_charge);
          }
        });
      }
    },
    addAdditionalChargeForSegundo(product) {
      let found = this.input.maincourse_ids.find(
        item => item.id === product.id
      );
      if (found) {
        this.input.maincourse_ids.map(item => {
          if (item.id === product.id) {
            return (item.additional_charge = product.additional_charge);
          }
        });
      }
    },
    addAdditionalChargeForDessert(product) {
      let found = this.input.dessert_ids.find(item => item.id === product.id);
      if (found) {
        this.input.dessert_ids.map(item => {
          if (item.id === product.id) {
            return (item.additional_charge = product.additional_charge);
          }
        });
      }
    },
    addAdditionalChargeForDrinks(product) {
      let found = this.input.drink_ids.find(item => item.id === product.id);
      if (found) {
        this.input.drink_ids.map(item => {
          if (item.id === product.id) {
            return (item.additional_charge = product.additional_charge);
          }
        });
      }
    },
    onDrinkSelect(product) {
      let foundIndex = this.input.drink_ids.findIndex(x => x.id === product.id);
      if (foundIndex === -1) {
        this.input.drink_ids.push({
          id: product.id,
          additional_charge: product.additional_charge
            ? product.additional_charge
            : 0
        });
      } else {
        this.input.drink_ids.splice(foundIndex, 1);
      }
    },
    onStarterSelect(product) {
      let foundIndex = this.input.starter_ids.findIndex(
        x => x.id === product.id
      );
      if (foundIndex === -1) {
        this.input.starter_ids.push({
          id: product.id,
          additional_charge: product.additional_charge
            ? product.additional_charge
            : 0
        });
      } else {
        this.input.starter_ids.splice(foundIndex, 1);
      }
    },
    onMainCourseSelect(product) {
      let foundIndex = this.input.maincourse_ids.findIndex(
        x => x.id === product.id
      );
      if (foundIndex === -1) {
        this.input.maincourse_ids.push({
          id: product.id,
          additional_charge: product.additional_charge
            ? product.additional_charge
            : 0
        });
      } else {
        this.input.maincourse_ids.splice(foundIndex, 1);
      }
    },
    onDessertSelect(product) {
      let foundIndex = this.input.dessert_ids.findIndex(
        x => x.id === product.id
      );
      if (foundIndex === -1) {
        this.input.dessert_ids.push({
          id: product.id,
          additional_charge: product.additional_charge
            ? product.additional_charge
            : 0
        });
      } else {
        this.input.dessert_ids.splice(foundIndex, 1);
      }
    },
    open(itemId) {
      this.dialog = true;
      this.id = itemId;

      if (this.id === "addMenu") {
        setTimeout(() => {
          this.title = "Crear Menu";
        }, 100);
        this.dialogLoader = false;
        return;
      } else {
        setTimeout(() => {
          this.title = "Editar Menu";
        }, 100);
      }

      this.dialogLoader = true;
      let self = this;

      getMenuGroupById(this.id)
        .then(menuGroup => {
          if (menuGroup) {
            self.input = menuGroup;
            self.menuGroupPrimary = self.input.primaryColor;
            self.menuGroupSecondary = self.input.secondaryColor;
          } else {
            this.close();
          }
          self.dialogLoader = false;
        })
        .catch(error => {
          self.dialogLoader = false;
          this.setlogError(
            "get_menu_group_by_id",
            "Obtained error message in open()",
            error.stack,
            this.$options.name
          );
        });
    },
    close() {
      this.dialog = false;
      this.input = {
        name: "",
        primaryColor: "",
        secondaryColor: "",
        starter_ids: [],
        maincourse_ids: [],
        drink_ids: [],
        dessert_ids: [],
        active: true,
        isDrink: false,
        isDessert: false,
        isStarter: false
      };
      this.menuGroupPrimary = "#7417BE";
      this.menuGroupSecondary = "#9E9E9E";

      this.$refs.form.resetValidation();
      this.resetDrinksPanel();
      this.resetFoodPanel();
      this.resetDessertPanel();
      this.resetFilters();
    },
    resetDrinksPanel() {
      this.drinksPanel = {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      };
    },
    resetFoodPanel() {
      this.foodPanel = {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      };
    },
    resetDessertPanel() {
      this.dessertPanel = {
        accordion: false,
        popout: false,
        inset: false,
        multiple: false,
        disabled: false,
        readonly: false,
        focusable: false,
        flat: false,
        hover: false,
        tile: false
      };
    },
    resetFilters() {
      this.searchPrimero = "";
      this.searchDrinks = "";
      this.searchDessert = "";
      this.searchMaincourse = "";
      this.drinksCategorySelected = "";
      this.primeroCategorySelected = "";
      this.segundoCategorySelected = "";
      this.dessertCategorySelected = "";
      this.drinksSelectionSelected = "";
      this.primeroSelectionSelected = "";
      this.segundoSelectionSelected = "";
      this.dessertSelectionSelected = "";
    },
    setImageUrl(data) {
      this.input.menu_image = data.url;
      this.$forceUpdate();
    },
    onChangeColor(type) {
      if (type === "menuGroupPrimary") {
        this.input.primaryColor = this.menuGroupPrimary;
      } else {
        this.input.secondaryColor = this.menuGroupSecondary;
      }
    },
    changeColor(type) {
      if (type === "menuGroupPrimary") {
        this.menuGroupPrimary = this.input.primaryColor;
      } else {
        this.menuGroupSecondary = this.input.secondaryColor;
      }
    }
  }
};
</script>

<style scoped>
.search-primero {
  max-width: 20%;
}
</style>
